import React, { useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useAuth } from '../context/auth-context'
import { 
    AboutUs, 
    AgriBusiness, 
    ConsultingLogo, 
    FoodNBev, 
    Service,
    ProjectExp,
    Team,
    Client1,Client2,Client3,Client4,Client5,Client6,Client7,Client8,Client9,
    Client10,Client11,Client12,Client13,Client14,Client15,Client16,Client17,
    Client18,Client19,Client20,Client21,Client22,Client23,Client24,Client25,
    Client26,Client27,Client28,Client29,Client30,
    Address
} from '../images';
import Marquee from 'react-fast-marquee';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from '@heroicons/react/24/outline';


const Services = () => {
    const { isAuth } = useAuth();
    const clients = [
        Client1,Client2,Client3,Client4,Client5,Client6,Client7,Client8,Client9,
        Client10,Client11,Client12,Client13,Client14,Client15,Client16,Client17,
        Client18,Client19,Client20,Client21,Client22,Client23,Client24,Client25,
        Client26,Client27,Client28,Client29,Client30
    ]

    return (
        <section id="shop">
            <Container fluid>
            <Row className="bg-light d-flex flex-column align-items-center justify-content-center mb-0">
                <Col 
                    md={12} 
                    lg={12} 
                    className="d-flex flex-column flex-md-row align-items-start align-items-md-center p-3"
                >
                    <img 
                        src={ConsultingLogo} 
                        alt="Logo" 
                        className="logo mb-3 mb-md-0 me-md-3" 
                        style={{ width: '7%', minWidth: '80px' }} 
                    />
                    
                    <div className="d-flex flex-column justify-content-center">
                        <h4 className="text-uppercase text-danger fw-700">SNF CONSULTING GROUP</h4>
                        <ul className="text-dark text-start d-flex flex-row justify-content-start align-items-start flex-wrap ps-0 mb-0 text-decoration-none list-unstyled">
                            <li className="me-3">Agribusiness - </li>
                            <li className="me-3">Food - </li>
                            <li className="me-3">Beverage - </li>
                            <li className="me-3">Consultants - </li>
                            <li className="me-3">Advisory</li>
                        </ul>
                        <span style={{fontSize: '.8rem'}} className='mb-1 mt-2'>
                            {
                                isAuth ? (
                                    <>
                                        <Link to="/customer/dashboard" className='text-success'>Dashboard</Link> 
                                        <ChevronRightIcon width={12} height={12} className='text-success' /> 
                                    </>
                                ): (
                                    <>
                                        <Link to="/" className='text-success'>Home</Link> 
                                        <ChevronRightIcon width={12} height={12} className='text-success' /> 
                                    </>
                                )
                            }
                            <small>Services</small>
                        </span>
                    </div>
                </Col>
            </Row>
                <Row className='d-flex flex-column flex-md-row justify-content-center align-items-center my-0 p-3'>
                    <Col md={6}>
                        <h4 className="header-linear text-dark fw-bold fs-4 my-4">About Us</h4>
                        <p className="text-dark fs-6">
                            <span className='text-danger fw-800'>SNF consulting group</span> is a full service industry specialists, experts, 
                            consultants and adviser to agribusiness, food and beverage companies. 
                            We help create solutions that deliver the right product, for the right market at the right price.&nbsp; <br /><br />
                            <span className='text-danger fw-800'>SNF consulting group</span> provides technical assistance on a short term or long term basis. 
                            We work closely with clients to define their technical and business requirements and subsequently deliver 
                            measurable and comprehensive solutions that improve business performance and market value 
                        </p>
                    </Col>
                    <Col md={5} className='d-flex justify-content-end'>
                        <img src={AboutUs} alt="About Us" className="img-fluid" style={{ width: '60%' }} />
                    </Col>
                </Row>
                <Row className='bg-light d-flex flex-column flex-md-row justify-content-center align-items-center my-5 p-3'>
                    <Col md={6}>
                        <h4 className="header-linear text-dark fw-bold fs-4 my-4">Our Services</h4>
                        <p className="text-dark fs-6">
                            Our experience and expertise are focused on agricultural, food and beverage 
                            businesses of various category and sizes. We have the capability and expertise to 
                            develop and bring products to the market at a fraction of the cost of current imports.
                        </p>
                    </Col>
                    <Col md={5} className='d-flex justify-content-end'>
                        <img src={Service} alt="Service" className="img-fluid" style={{ width: '60%' }} />
                    </Col>
                </Row>
                <Row className='d-flex flex-column flex-md-row justify-content-center align-items-center my-5 p-3'>
                    <Col md={6}>
                        <h4 className="header-linear text-dark fw-bold fs-4 my-4">Agribusiness Solutions</h4>
                        <Row className='d-flex flex-row align-items-start mb-3 justify-content-space-between w-100'>
                            <Col md={6} className='d-flex flex-column'>
                                <ul style={{lineHeight: '2rem'}}>
                                    <li className="text-dark fs-6">Concept development</li>
                                    <li className="text-dark fs-6">New Ventures Evaluation</li>
                                    <li className="text-dark fs-6">Due Diligence</li>
                                    <li className="text-dark fs-6">Opportunity Analysis</li>
                                </ul>
                            </Col>
                            <Col md={6} className='d-flex flex-column'>
                                <ul style={{lineHeight: '2rem'}}>
                                    <li className="text-dark fs-6">Business Development</li>
                                    <li className="text-dark fs-6">Business and strategy plan</li>
                                    <li className="text-dark fs-6">Executive Coach and Advisor</li>
                                </ul>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={5} className='d-flex justify-content-end'>
                        <img src={AgriBusiness} alt="Service" className="img-fluid" style={{ width: '60%' }} />
                    </Col>
                </Row>
                <Row className='bg-light d-flex flex-column flex-md-row justify-content-center align-items-center my-5 p-3'>
                    <Col md={6}>
                        <h4 className="header-linear text-dark fw-bold fs-4 my-4">Food and Beverage Solutions</h4>
                        <Row className='d-flex flex-row align-items-start mb-3 justify-content-space-between w-100'>
                            <Col md={6} className='d-flex flex-column'>
                                <ul style={{lineHeight: '2rem'}}>
                                    <li className="text-dark fs-6">New Product Development</li>
                                    <li className="text-dark fs-6">Product cost reduction</li>
                                    <li className="text-dark fs-6">Executive Coaching and advisory</li>
                                    <li className="text-dark fs-6">Ideation and Innovation</li>
                                    <li className="text-dark fs-6">Ingredient Review and product Reformulation</li>
                                    <li className="text-dark fs-6">Manufacturing Support and Operations</li>
                                    <li className="text-dark fs-6">Process Control</li>
                                </ul>
                            </Col>
                            <Col md={6} className='d-flex flex-column'>
                                <ul style={{lineHeight: '2rem'}}>
                                    <li className="text-dark fs-6">Quality Control</li>
                                    <li className="text-dark fs-6">Research and Development</li>
                                    <li className="text-dark fs-6">Technical Training</li>
                                    <li className="text-dark fs-6">Taste and Sensory Testing</li>
                                    <li className="text-dark fs-6">Flavor evaluation and Testing</li>
                                    <li className="text-dark fs-6">Product test and roll out</li>
                                    <li className="text-dark fs-6">Technical Research and Development</li>
                                    <li className="text-dark fs-6">Cost of goods analysis</li>
                                    <li className="text-dark fs-6">Manufacturing improvement</li>
                                </ul>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={5} className='d-flex justify-content-end'>
                        <img src={FoodNBev} alt="Food and Beverages" className="img-fluid" style={{ width: '60%' }} />
                    </Col>
                </Row>
                <Row className='d-flex flex-column flex-md-row justify-content-center align-items-center my-5 p-3'>
                    <Col md={6}>
                        <h4 className="header-linear text-dark fw-bold fs-4 my-4">Project Experience</h4>
                        <Row className='d-flex flex-row align-items-start mb-3 justify-content-space-between w-100'>
                            <p className="text-dark fs-6"> Our team has been instrumental in development and roll out of several global food and beverage products such as</p>
                            <ul style={{lineHeight: '2rem', listStylePosition: 'inside'}}>
                                <li className="text-dark fs-6" style={{textAlign: 'justify'}}>Intellectual property development, product and formulation of Hibiscus Cordial for local and International markets for Agroeknor International. Manufacturing of Madala Cordial for global markets.</li>
                                <li className="text-dark fs-6" style={{textAlign: 'justify'}}>Development, manufacturing and rollout of a new orange flavor for a global carbonated orange drink product for the Dr. Pepper Snapple group.</li>
                                <li className="text-dark fs-6" style={{textAlign: 'justify'}}>Development, matching and manufacturing of the Starbucks coffee flavor in an alcoholic coffee liqueur beverage for Jim Beam and Starbucks Company.</li>
                                <li className="text-dark fs-6" style={{textAlign: 'justify'}}>Development and manufacturing of tingling and numbing extracts and tincture containing spilantol from spilanthes acmelia in mouthwash and oral care applications</li>
                                <li className="text-dark fs-6" style={{textAlign: 'justify'}}>New product development, roll out and commercialization  of  baked good products such as Chocolate chip cookies, cocoa based biscuits, cookies and crackers, cheese nips and graham crackers in baked good multinational company.</li>
                                <li className="text-dark fs-6" style={{textAlign: 'justify'}}>Flavor development in consumer products such as foods, dairy, beverages, confectionery, and oral care products. Carbonated and non carbonated beverage development, new flavor innovation and development.</li>
                                <li className="text-dark fs-6" style={{textAlign: 'justify'}}>Flavor and natural products identification, isolation, extractions, distillations & commercialization. Reaction and process chemistry for creating coffee, chocolate, vanilla and savory building blocks.</li>
                                <li className="text-dark fs-6" style={{textAlign: 'justify'}}>Food and flavor product and process development, pilot and production plant scale up. Flavor characterization, evaluation, and shelf life extension and stability studies in food and beverages.</li>
                                <li className="text-dark fs-6" style={{textAlign: 'justify'}}>Expertise and capability to develop new flavors, match and manufacture existing flavors, develop and match current imported flavors and assist in formulating solutions to flavor application, flavor release, flavor stability and flavor shelf life extension initiatives.</li>
                            </ul>
                        </Row>
                    </Col>
                    <Col md={5} className='d-flex justify-content-end'>
                        <img src={ProjectExp} alt="Project Experience" className="img-fluid" style={{ width: '60%' }} />
                    </Col>
                </Row>
                <Row className='bg-light d-flex flex-column flex-md-row justify-content-center align-items-center my-5 p-3'>
                    <Col md={6}>
                        <h4 className="header-linear text-dark fw-bold fs-4 my-4">Integrated Approach to Problem Solving</h4>
                        <p className="text-dark fs-6" style={{textAlign: 'justify'}}>
                            We employ an integrated approach to product development, problems solving and technical 
                            solutions. We combine consumer insights, marketing knowledge, ingredient technologies 
                            and formulations development, product development innovation, packaging  and processing 
                            technologies and project management.
                        </p>
                    </Col>
                    <Col md={5} className='d-flex justify-content-end'>
                        
                    </Col>
                </Row>
                <Row className='d-flex flex-column flex-md-row justify-content-center align-items-center my-5 p-3'>
                   
                    <Col md={8}>
                        <div className='d-flex flex-row overflow-hidden justify-content-center align-items-center my-5'>
                        <Marquee 
                            speed={50} 
                            autoFill={true}
                            pauseOnHover={true}
                        >
                            {clients.map((client, i) => (
                                <img 
                                key={i} 
                                src={client} 
                                alt={`partner-${i}`} 
                                style={{ margin: '0 10px', cursor: 'pointer' }}
                                />
                            ))}
                        </Marquee>
                        </div>
                        <p className="text-dark fs-6 text-center my-5">Some Global Brands Group Participated in Development and Roll-out</p>
                    </Col>
                </Row>
                <Row className='bg-light d-flex flex-column flex-md-row justify-content-center align-items-center my-5 p-3'>
                    <Col md={6}>
                        <h4 className="header-linear text-dark fw-bold fs-4 my-4">Our Management Team</h4>
                        <p className="text-dark fs-6" style={{textAlign: 'justify'}}>
                            Dr Adedeji is the principal scientist, he is a dynamic visionary, entrepreneurial academic and business owner with expertise and interest in using advanced technology to create value in every sector of the global agricultural value chain in which he has 30 years’ experience from 3 continents spanning product development and trademarks of over 30 new foods, beverages, and confectionery, flavor and fragrance products. He has numerous publications, presentations and US patents in his field.
                        </p>
                        <p className="text-dark fs-6" style={{textAlign: 'justify'}}>
                            As the pioneer Chief Executive Officer of Teragro, the agribusiness subsidiary of The Transnational Corporation of Nigeria, Transcorp, he set-up the first commercial juice concentrate factory and business in Nigeria that supplied concentrates to the Coca-Cola company in Nigeria. He is an agribusiness turnaround expert and strategist with world class technical know-how and skills.
                        </p>
                        <p className="text-dark fs-6" style={{textAlign: 'justify'}}>
                            Dr Adedeji is an entrepreneur, scientist, innovator and business owner with strong interest in value added agro-industrial business enterprises in Africa and the USA, he is founder and Chief Executive Officer of Easysauces Nigeria Limited, owners of the Obe Sauce™ trademark. Easysauces recently developed and supply Meals Ready to Eat (MREs) to Nigeria Military and Defence forces in prosecution and maintenance of National Defence and Security.
                        </p>
                        <p className="text-dark fs-6" style={{textAlign: 'justify'}}>
                            Dr. Adedeji has a Ph.D. and Master’s degree in Food Science from Rutgers University, New Brunswick, New Jersey. He has a Master of Science degree and postgraduate Diploma in Food Science and Technology from the University of Ibadan, Nigeria and a bachelor’s degree in Agricultural Biochemistry and Nutrition from the same institution.  He has various research affiliations with The Center for Advanced Food Technology (CAFT) in New Brunswick New Jersey.  He is a professional member of the Institute of Food Technologists, Chicago, Illinois and The American Chemical Society (ACS), Washington DC. 
                        </p>
                        <p className="text-dark fs-6" style={{textAlign: 'justify'}}>
                            Dr Adedeji is the Academic Director of Agribusiness Management Program, AgMP at the Lagos Business School with executive education teaching and research work focused on transformation, creation and addition of value to agricultural commodities and raw materials across value chains in Africa. Dr Adedeji sits on the board of several Agribusiness enterprises in Nigeria.
                        </p>
                    </Col>
                    <Col md={5} className='d-flex justify-content-end'>
                        <img src={Team} alt="Project Experience" className="img-fluid" style={{ width: '60%' }} />
                    </Col>
                </Row>
                <Row className='d-flex flex-column flex-md-row justify-content-center align-items-center my-5 p-3'>
                    <Col md={6}>
                        <h4 className="header-linear text-dark fw-bold fs-4 my-4">Contact us</h4>
                        <Row className='d-flex flex-row align-items-start mb-3 justify-content-space-between w-100'>
                            <Col md={3} className='d-flex flex-column'>
                                <h6>Address:</h6>
                            </Col>
                            <Col md={6} className='d-flex flex-column'>
                                <p className="text-dark fs-6" style={{textAlign: 'justify'}}>
                                    <strong>1 Easysauces Lane</strong><br />
                                    Okolomi Village, (Off Bogije Bus Stop) <br />
                                    Ibeju-Lekki, Lagos. Nigeria <br />
                                    <a href="tel:+2347059508080">+234 705 950 8080</a> <br />
                                </p>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={5} className='d-flex justify-content-end'>
                        <img src={Address} alt="Address" className="img-fluid" style={{ width: '100%' }} />
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Services
